import {
  WHATSAPP_SETUP,
  PHONE_NUMBER_ID,
  CURRENT_WORKSPACE_KEY,
} from "src/config/constants";

const CONNECTION_CHANGED = "whatsapp-connection-changed";

export const connectionSnapshot = () => localStorage.getItem(WHATSAPP_SETUP);

export function parseConnection(snapshot) {
  try {
    const value = JSON.parse(snapshot);
    return value?.workspaceId &&
      value?.whatsappAccountId &&
      value?.phoneNumberId
      ? value
      : null;
  } catch {
    return null;
  }
}

export function subscribeConnection(listener) {
  window.addEventListener(CONNECTION_CHANGED, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(CONNECTION_CHANGED, listener);
    window.removeEventListener("storage", listener);
  };
}

export function storeConnection(settings) {
  const connection =
    settings?.active_workspace_id &&
    settings?.active_whatsapp_account_id &&
    settings?.active_phone_number_id
      ? {
          workspaceId: settings.active_workspace_id,
          whatsappAccountId: settings.active_whatsapp_account_id,
          phoneNumberId: settings.active_phone_number_id,
        }
      : null;
  if (connection) {
    localStorage.setItem(WHATSAPP_SETUP, JSON.stringify(connection));
    localStorage.setItem(PHONE_NUMBER_ID, connection.phoneNumberId);
    localStorage.setItem(CURRENT_WORKSPACE_KEY, connection.workspaceId);
  } else {
    [WHATSAPP_SETUP, PHONE_NUMBER_ID, CURRENT_WORKSPACE_KEY].forEach((key) =>
      localStorage.removeItem(key),
    );
  }
  window.dispatchEvent(new Event(CONNECTION_CHANGED));
  return connection;
}
